var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify-dialog"},[_c('el-dialog',{attrs:{"title":"请扫描二维码","width":"30%","visible":_vm.myValue,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.myValue=$event},"close":_vm.close}},[_c('div',{staticClass:"qr-box"},[_c('el-image',{attrs:{"src":_vm.qrUrl}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27628f67","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/previewDialog.vue
// module id = null
// module chunks = 